<template>
  <div>
    <section class="title">
      <b-container>
        <h3>{{ $t("landing_eightPillars_title") }}</h3>
      </b-container>
    </section>
    <b-container>
      <p class="description">
        {{ $t("landing_eightPillars_description") }}
      </p>
      <div
        v-for="(pillar, pillarIndex) in pillars"
        :id="pillar"
        :key="pillarIndex"
        class="pillar"
      >
        <div class="acronym">
          {{ $t("label_indicator_pillar_" + pillar + "_acronym") }}
        </div>
        <b-row>
          <b-col lg="3" offset-lg="1" md="4">
            <div class="card-image">
              <img
                :src="'/static/images/pillars/' + pillar + '_icon.svg'"
                class="card-img-top"
              />
              <h2>{{ $t("label_indicator_pillar_" + pillar + "_name") }}</h2>
            </div>
          </b-col>
          <b-col>
            <p>{{ $t("label_indicator_pillar_" + pillar + "_description") }}</p>
            <h4>{{ $t("landing_eightPillars_subPillars") }}</h4>
            <div
              v-html="$t('label_indicator_pillar_' + pillar + '_subPillars')"
            />
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pillars: ["OP", "PP", "RSH", "PDP", "R", "PH", "WLBS", "COM"],
    };
  },
};
</script>

<style lang="sass" scoped>

.title
  text-align: center
  background-color: #e7e7ec
  height: 75px
  font-size: 1.1rem
  display: flex
  vertical-align: middle
  justify-content: center
  flex-direction: column
  text-transform: uppercase
  border-top: 2px solid #000

.description
  text-align: center
  margin: 30px

.pillar
  border: 2px solid #464e55
  border-radius: 15px
  min-height: 340px
  display: flex
  vertical-align: middle
  justify-content: center
  flex-direction: column
  position: relative
  padding: 20px
  margin-bottom: 35px

  .acronym
    height: 106px
    width: 106px
    background-color: #231f20
    color: #fff
    border-radius: 100%
    display: flex
    justify-content: center
    flex-direction: column
    text-align: center
    font-size: 2.3rem
    position: absolute
    left: -53px
  img
    height: 165px
  h2
    font-size: 1.8rem
    text-transform: uppercase
    text-align: center
    margin-top: 20px

  h4
    font-size: 1rem
    text-transform: uppercase

@media (max-width: 576px)
  .pillar .acronym
    height: 70px
    width: 70px
    top: -15px
    right: -15px
    left: unset
    font-size: 1.3rem
</style>
